import { render, staticRenderFns } from "./ZxFawuPanjueForm.vue?vue&type=template&id=2170e3fa&scoped=true&"
import script from "./ZxFawuPanjueForm.vue?vue&type=script&lang=js&"
export * from "./ZxFawuPanjueForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2170e3fa",
  null
  
)

export default component.exports